import { render, staticRenderFns } from "./BuyBoxOffer.vue?vue&type=template&id=36518f4e&scoped=true&"
import script from "./BuyBoxOffer.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BuyBoxOffer.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BuyBoxOffer.vue?vue&type=style&index=0&id=36518f4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36518f4e",
  null
  
)

export default component.exports